/* 
* File: \app\resourceCenter\directive\atlasPreview\atlasPreview.js
* Description: 图集稿列表项目指令
* Create Date: 2020-05-13
* Author: he.jianbo
* Author Email: hjb2722404@163.com
* -----
* Last Modified: 2020-05-13 上午11:18:46
* Modified By: he.jianbo
* modify description: 
* -----
* HISTORY:
* 日期                    	作者	说明
* -----------	---	----------------------------------------------------------
 */

'use strict';
angular.module('resourceCenterModule')
    .directive('atlasPreview', ['$state', '$timeout', 'resourceCenterService', 'xinhuaApiService', function($state, $timeout, resourceCenterService, xinhuaApiService) {
        return {
            restrict: 'E',
            scope: false,
            templateUrl: './resourceCenter/directive/atlasPreview/atlasPreview_tpl.html',
            link: function(scope) {
                // 默认列表高度
                scope.status = {
                    defaultHeight: 180,
                };
                // 传输对象
                scope.showData = [];
                // 展示对象
                scope.realShow = [];

                scope.$watch('data.items', () => {
                    scope.showData = typeof scope.data.items === 'string' ? JSON.parse(scope.data.items) : scope.data.items;
                    initData();
                });

                /**
                 * [initData description]初始化数据
                 *
                 * @return  {[type]}  [return description]
                 */
                function initData() {
                    if (typeof scope.showData === 'object' && scope.showData.length > 0) {
                        dueEachStyle();
                    }
                }

                /**
                 * [dueEachStyle description]处理基础显示比例的宽高
                 *
                 * @return  {[type]}  [return description]
                 */
                function dueEachStyle() {
                    const delIndex = [];
                    scope.realShow = [];
                    scope.showData.forEach((item, index) => {
                        item.showHeight = scope.status.defaultHeight;
                        if (item[scope.childStatus.checkString].length === 0) {
                            delIndex.push(index);
                        } else {
                            if (item[scope.childStatus.checkString][0].WIDTH && item[scope.childStatus.checkString][0].HEIGHT) {
                                item.showWidth = item[scope.childStatus.checkString][0].WIDTH / item[scope.childStatus.checkString][0].HEIGHT * scope.status.defaultHeight;
                            } else {
                                item.showWidth = 230;
                            }
                            item[scope.childStatus.checkString].forEach((picList) => {
                                picList.showHeight = scope.status.defaultHeight;
                                if (picList.WIDTH && picList.HEIGHT) {
                                    picList.showWidth = picList.WIDTH / picList.HEIGHT * scope.status.defaultHeight;
                                } else {
                                    picList.showWidth = 230;
                                }
                            });
                            scope.realShow.push(item);
                        }
                    });
                    computeList();
                    $timeout(() => {
                        if (scope.status.isShowMore) {
                            scope.status.topSet = document.getElementsByClassName('eachAutoMain')[scope.status.chooseIndex].offsetTop + scope.realShow[scope.status.chooseIndex].showHeight + 75;
                            scope.status.leftSet = document.getElementsByClassName('eachAutoMain')[scope.status.chooseIndex].offsetLeft + scope.realShow[scope.status.chooseIndex].showWidth / 2 - 15;
                        }
                    });
                }

                /**
                 * [computeList description]将图片进行计算分组
                 *
                 * @return  {[type]}  [return description]
                 */
                function computeList() {
                    const list = [[]];
                    const domWidth = document.getElementsByClassName('atlas-preview')[0].offsetWidth - 10;
                    const showMoreDom = domWidth - 33;
                    let index = 0;
                    let indexAll = 0;
                    scope.realShow.forEach((item, checkIndex) => {
                        if ((indexAll + item.showWidth / 2) > (domWidth - 10 * list[index].length)) {
                            list[index][list[index].length - 1].total = indexAll;
                            index++;
                            indexAll = item.showWidth;
                            list.push([item]);
                        } else {
                            list[index].push(item);
                            indexAll = indexAll + item.showWidth;
                            if (checkIndex === scope.realShow.length - 1) {
                                list[index][list[index].length - 1].total = indexAll;
                            }
                        }
                        let picIndex = 0;
                        let picIndexAll = 0;
                        const newlist = [[]];
                        item[scope.childStatus.checkString].forEach((picList, picCheckIndex) => {
                            if ((picIndexAll + picList.showWidth / 2) > (showMoreDom - 10 * newlist[picIndex].length)) {
                                newlist[picIndex][newlist[picIndex].length - 1].total = picIndexAll;
                                picIndex++;
                                picIndexAll = picList.showWidth;
                                newlist.push([picList]);
                            } else {
                                newlist[picIndex].push(picList);
                                picIndexAll = picIndexAll + picList.showWidth;
                                if (picCheckIndex === scope.realShow.length - 1) {
                                    newlist[picIndex][newlist[picIndex].length - 1].total = picIndexAll;
                                }
                            }
                        });
                        computeEachStyle(newlist, true);
                    });
                    computeEachStyle(list);
                }

                /**
                 * [computeEachStyle description]计算具体每一张图片的样式
                 *
                 * @param   {[type]}  list   [list description]传入处理好的list数据
                 * @param   {[type]}  check  [check description]
                 *
                 * @return  {[type]}         [return description]
                 */
                function computeEachStyle(list, check) {
                    const domWidth = document.getElementsByClassName('atlas-preview')[0].offsetWidth;
                    const showMoreDom = domWidth - 33;
                    const useDom = check ? showMoreDom : domWidth;
                    list.forEach((line, index) => {
                        const lineWidth = line[line.length - 1].total;
                        const lineHeight = useDom / lineWidth * scope.status.defaultHeight;
                        if (index !== list.length - 1 || lineWidth > useDom) {
                            line.forEach((dom) => {
                                dom.showHeight = lineHeight;
                                dom.showWidth = useDom / lineWidth * dom.showWidth - line.length / line.length * 10;
                            });
                        }
                    });
                }

                /**
                 * [showAtlasCarouselWindow 显示图集预览弹窗]
                 *
                 * @param   {[type]}  item  [item description]
                 * @param   {[type]}  index  [当前项目序号]
                 *
                 * @return  {[type]}        [return description]
                 */
                scope.showAtlasCarouselWindow = function (item, index) {
                    let options = scope.getAtlasCarouselWindowOptions(item);
                    resourceCenterService.showAtlasCarouselWindow(options);
                    if (index === scope.status.chooseIndex) {
                        scope.status.chooseIndex = null;
                        scope.status.isShowMore = false;
                        return;
                    }
                };

                /**
                 * [throttle description]节流函数
                 *
                 * @param   {[type]}  func   [func description]
                 * @param   {[type]}  delay  [delay description]
                 *
                 * @return  {[type]}         [return description]
                 */
                var throttle = function(func, delay) {
                    var timer = null;
                    return function() {
                        var context = this;
                        var args = arguments;
                        if (!timer) {
                            timer = setTimeout(function() {
                                func.apply(context, args);
                                timer = null;
                            }, delay);
                        }
                    };
                };
                window.onresize = throttle(dueEachStyle, 500);
                
                /**
                 * [sortOutShared description] 整理共享人显示，为了兼容窄图，
                 *
                 * @param   {[type]}  item  [item description]
                 *
                 * @return  {[type]}        [return description]
                 */
                scope.sortOutShared = function(item) {
                    if (scope.childStatus.isShowAtlasShared) {
                        if (scope.childStatus.isCountyFeed) {
                            item.sharedTitleShow = '供稿单位：' + item.FROMTENANTNAME;
                        } else {
                            item.sharedTitleShow = '共享人：' + (item.SHAREUSRTRUENAME || item.FGDAUTHOR);
                        }
                    }
                };

                /**
                 * [showMorePic description]展示图集详情图片
                 *
                 * @param   {[type]}  index  [index description]图集详情选择
                 * @param   {[type]}  item  [index description]要展示的图集
                 *
                 * @return  {[type]}         [return description]
                 */
                scope.showMorePic = function(index, item) {
                    if (index === scope.status.chooseIndex) {
                        scope.status.chooseIndex = null;
                        scope.status.isShowMore = false;
                        return;
                    }
                    scope.status.isShowMore = true;
                    scope.status.chooseIndex = index;
                    scope.status.showMorePic = scope.realShow[index][scope.childStatus.checkString];
                    scope.status.topSet = document.getElementsByClassName('eachAutoMain')[index].offsetTop + scope.realShow[index].showHeight + 75;
                    scope.status.leftSet = document.getElementsByClassName('eachAutoMain')[index].offsetLeft + scope.realShow[index].showWidth / 2 - 15;
                    scope.showAtlasCarouselWindow(item, index);
                };


            }
        };
    }]);
